/**
 * Typography of the app chrome, mirrored from the design system's own class
 * names so the header does not re-invent them per breakpoint.
 *
 * Deliberately only the chrome. The full role-based scale (card titles, table
 * cells, captions) is written up in the design spec and belongs here when the
 * page-level typography pass lands — adding it before anything consumes it
 * would just be a table nobody reads.
 */

type TypeToken = {
  fontSize: number;
  fontWeight: number;
  letterSpacing?: string;
  lineHeight?: number;
};

export const insucoachType = {
  /** `.crumb` — breadcrumb trail; the current crumb differs only in colour. */
  crumb: { fontSize: 13.5, fontWeight: 600 },
  /** `.m-parent-title` — phone header on a list page. */
  mobilePageTitle: { fontSize: 18, fontWeight: 800 },
  /** `.m-child-title` — phone header on a page below a list. */
  mobileTitle: { fontSize: 15.5, fontWeight: 800, lineHeight: 1.2 },
  /** `.m-child-eyebrow` — the parent's name above that title. */
  mobileEyebrow: { fontSize: 10, fontWeight: 800, letterSpacing: '0.08em', lineHeight: 1.1 },
} as const satisfies Record<string, TypeToken>;
